/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_7_SolutionInputs */

const et_portfolio_project_7_solution = /** @type {(inputs: Portfolio_Project_7_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kujundasime kasutajateekonna ümber, lihtsustasime navigatsiooni ja rakendasime CRO parimaid praktikaid.`)
};

const en_portfolio_project_7_solution = /** @type {(inputs: Portfolio_Project_7_SolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redesigned user journey, simplified navigation, and implemented CRO best practices.`)
};

/**
* | output |
* | --- |
* | "Redesigned user journey, simplified navigation, and implemented CRO best practices." |
*
* @param {Portfolio_Project_7_SolutionInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_7_solution = /** @type {((inputs?: Portfolio_Project_7_SolutionInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_7_SolutionInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_7_solution(inputs)
	return en_portfolio_project_7_solution(inputs)
});